import Base64Image from 'component/Base64Image'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background: var(--component-area-swiper--background);
  padding: 0rem 0;
  color: white;
`

export const StyledBase64Image = styled(Base64Image).attrs({ aspectRatio: null })`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
`
